module.exports = __webpack_public_path__ + "static/key-naezith-bcce6941667d368ff85ed2a37bfbb43c.webp";